import type { CSSProperties } from 'react';

import type { StaticTagCountryGroup } from '../../hooks/useStaticTagPropagation';

export function tagNamesFromGroups(groups: StaticTagCountryGroup[]): string[] {
  const s = new Set<string>();
  for (const g of groups) for (const t of g.tags) s.add(t.tagName);
  return [...s].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

export function propagatableGroups(groups: StaticTagCountryGroup[]): StaticTagCountryGroup[] {
  return groups.filter((g) => !g.isBulkSourceCountry);
}

export function withoutBulkSourceKeys(groups: StaticTagCountryGroup[], keys: string[]): string[] {
  const bulk = new Set(groups.filter((g) => g.isBulkSourceCountry).map((g) => g.countryKey));
  return keys.filter((k) => !bulk.has(k));
}

export function staticTagChipStyle(hex?: string | null): CSSProperties | undefined {
  if (!hex) return undefined;
  return {
    backgroundColor: `${hex}26`,
    color: hex,
    borderColor: `${hex}55`,
  };
}

export function staticTagFilterButtonStyle(
  hex: string | undefined,
  selected: boolean,
): CSSProperties | undefined {
  if (!hex) return undefined;
  return {
    backgroundColor: `${hex}${selected ? '40' : '26'}`,
    color: hex,
    borderColor: `${hex}${selected ? '70' : '50'}`,
  };
}
